import {Badge, Tabs} from 'antd';
import {checkPerm} from "../auth/sessionTools";
import {Outlet, useNavigate} from "react-router";

export const TabController = ({session, numTasks}) => {
    const navigate = useNavigate();
    const onTabClick = (key, event) => {
        switch (key) {
            case 'General':
                navigate('/general');
                break;
            case 'Tasks':
                navigate('/tasks');
                break;
            case 'Inventory':
                navigate('/inventory');
                break;
            case 'Sales':
                navigate('/sales')
                break;
            case 'OutsideSales':
                navigate('/outsidesales');
                break;
            case 'Buyers':
                navigate('/buyers')
                break;
            case 'Returns':
                navigate('/returns')
                break;
            case 'Fulfillment':
                navigate('/fulfillment')
                break;
            case 'Cultivation':
                navigate('/cultivationapp')
                break;
            case 'Manufacturing':
                navigate('/manufacturing')
                break;
            case 'Graphics':
                navigate('/graphics')
                break;
            case 'Operations':
                navigate('/operations')
                break;
            case 'TrapconRetail':
                navigate('/trapconretail')
                break;
            case 'Accounting':
                navigate('/accounting')
                break;
            case 'Admin':
                navigate('/admin')
                break;
            case 'Contacts':
                navigate('/contacts');
                break;
            default:
        }
    };

    // const onTabClick = (key, e) => {
    //     console.log(`tab ${key}`);
    // }

    const items = [
        {
            key: 'General',
            label: 'General',
            children: <div />,
        },
        {
            key: 'Tasks',
            label: <Badge count={numTasks} offset={[8, 0]} size={'small'}>Tasks</Badge>,
            children: <div />
        }
    ];

    if (checkPerm(session, "inventory")) {
        items.push({
            key: 'Inventory',
            label: 'Inventory',
            children: <div />
        });
    }

    if (checkPerm(session, "sales")) {
        items.push(
        {
            key: 'Sales' ,
            label: 'Sales',
            children: <div />
        });
        items.push({
            key: 'Buyers',
            label: 'Buyers',
            children: <div />
        });
        items.push({
            key: 'Contacts',
            label: 'Vendors',
            children: <div />,
        });
        items.push({
            key: 'Returns',
            label: 'Returns',
            children: <div />
        });
    }

    if (checkPerm(session, "outsidesales")) {
        items.push({
            key: 'OutsideSales',
            label: 'Outside Sales',
            children: <div/>
        });
    }

    if (checkPerm(session, "fulfillment")) {
        items.push({
            key: 'Fulfillment',
            label: 'Fulfillment',
            children: <div />
        })
    }

    if (checkPerm(session, "cultivation")) {
        items.push({
            key: 'Cultivation',
            label: 'Cultivation',
            children: <div />
        })
    }

    if (checkPerm(session, "manufacturing")) {
        items.push({
            key: 'Manufacturing',
            label: 'Manufacturing',
            children: <div />
        })
    }

    if (checkPerm(session, "graphics")) {
        items.push({
            key: 'Graphics',
            label: 'Graphics',
            children: <div />
        })
    }

    if (checkPerm(session, "operations")) {
        items.push({
            key: 'Operations',
            label: 'Operations',
            children: <div />
        })
    }

    if (checkPerm(session, "trapconretail")) {
        items.push({
            key: 'TrapconRetail',
            label: 'Trapcon Retail',
            children: <div />
        })
    }

    if (checkPerm(session, "accounting")) {
        items.push({
            key: 'Accounting',
            label: 'Accounting',
            children: <div />
        });
    }

    if (checkPerm(session, "executive")) {
        items.push({
            key: 'Admin',
            label: 'Admin',
            children: <div />
        })
    }


    return <>
        <Tabs defaultActiveKey={"General"} items={items} onTabClick={onTabClick}/>
        <Outlet />
    </>
}